import React from 'react'
import './editprojectroles.css';

const EditProjectRoles = ({ projectroles, handleDeleteRole }) => {
    return (
        <div style={{ marginTop: '1.5rem' }}>
            {projectroles.length > 0 ? (
                <div>
                {projectroles.map((role, index) => (
                    <div key={index} style={{ marginBottom: '1rem' }}>
                        <p style={{ marginBottom: '1rem' }}>{role.role_name} <button className='projrolesdelbtn' onClick={()=>handleDeleteRole(role.role_id)}><i class="fa-solid fa-trash"></i></button></p>
                        <ul style={{ fontWeight: '300' }}>
                            <li>{role.role_description}</li>
                        </ul>
                    </div>
                ))}
            </div>
            ) : (
                <div>
                    <span>No roles added</span>
                </div>
            )}
        </div>
    )
}

export default EditProjectRoles